import api from '@/helpers/api'

const API_URL = '/api/client/newsletters'

export default {
    namespaced: true,
    state: {
        status: '',
        detailStatus: '',
        newsletters: [],
        newslettersById: {},
        currentNewsletter: null,
        unreadCount: 0,
        meta: {
            page: 1,
            limit: 5,
            total: 0,
            last_page: 0
        }
    },
    mutations: {
        request(state) {
            state.status = 'loading'
        },
        success(state) {
            state.status = 'success'
        },
        error(state) {
            state.status = 'error'
        },
        detailRequest(state) {
            state.detailStatus = 'loading'
        },
        detailSuccess(state) {
            state.detailStatus = 'success'
        },
        detailError(state) {
            state.detailStatus = 'error'
        },
        setNewsletters(state, data) {
            state.newsletters = data
            if (Array.isArray(data)) {
                const updatedDict = { ...state.newslettersById }
                data.forEach(item => {
                    if (item && item.id) {
                        const existing = updatedDict[item.id] || {}
                        updatedDict[item.id] = {
                            ...existing,
                            ...item,
                            // Preserve complete article body if existing cache had it and list item has empty/null body
                            body: (item.body !== undefined && item.body !== null && item.body !== '') 
                                ? item.body 
                                : (existing.body || '')
                        }
                    }
                })
                state.newslettersById = updatedDict
            }
        },
        setCurrentNewsletter(state, data) {
            state.currentNewsletter = data
            if (data && data.id) {
                state.newslettersById = {
                    ...state.newslettersById,
                    [data.id]: data
                }
            }
        },
        setUnreadCount(state, count) {
            state.unreadCount = count
        },
        setRead(state, id) {
            if (state.newslettersById[id]) {
                state.newslettersById[id].is_read = true
            }
            const item = state.newsletters.find(n => n.id === id)
            if (item) {
                item.is_read = true
            }
        },
        setMeta(state, meta) {
            state.meta = meta
        },
        clearCurrentNewsletter(state) {
            state.currentNewsletter = null
        }
    },
    actions: {
        read({ commit }, params = {}) {
            commit('request')
            return new Promise((resolve, reject) => {
                const requestParams = {
                    meta: {
                        page: params.page || (params.meta ? params.meta.page : 1),
                        limit: params.limit || (params.meta ? params.meta.limit : 10)
                    }
                }

                if (params.filter) {
                    requestParams.filter = params.filter
                }
                if (params.search) {
                    requestParams.search = params.search
                }
                if (params.sort) {
                    requestParams.sort = params.sort
                }
                if (params.custom) {
                    requestParams.custom = params.custom
                }

                api.request('get', API_URL, requestParams)
                    .then((resp) => {
                        commit('success')
                        const data = resp.data

                        // Handle pagination structure
                        if (data && data.data && Array.isArray(data.data)) {
                            commit('setNewsletters', data.data)
                            if (data.meta) commit('setMeta', data.meta)
                        } else {
                            // Fallback
                            commit('setNewsletters', Array.isArray(data) ? data : [])
                        }
                        resolve(resp)
                    })
                    .catch((err) => {
                        commit('error')
                        reject(err)
                    })
            })
        },
        readById({ commit }, id) {
            commit('detailRequest')
            return new Promise((resolve, reject) => {
                api.request('get', `${API_URL}/${id}`)
                    .then((resp) => {
                        commit('detailSuccess')
                        commit('setCurrentNewsletter', resp.data.data)
                        resolve(resp)
                    })
                    .catch((err) => {
                        commit('detailError')
                        reject(err)
                    })
            })
        },
        getUnreadCount({ commit }) {
            return new Promise((resolve, reject) => {
                api.request('get', `${API_URL}/unread-count`)
                    .then((resp) => {
                        commit('setUnreadCount', resp.data.data.count)
                        resolve(resp)
                    })
                    .catch((err) => reject(err))
            })
        },
        markAsRead({ commit }, id) {
            return new Promise((resolve, reject) => {
                api.request('post', `${API_URL}/${id}/read`)
                    .then((resp) => {
                        commit('setRead', id)
                        resolve(resp)
                    })
                    .catch((err) => reject(err))
            })
        }
    },
    getters: {
        newsletters: state => state.newsletters,
        isLoading: state => state.status === 'loading',
        isDetailLoading: state => state.detailStatus === 'loading',
        currentNewsletter: state => state.currentNewsletter,
        getNewsletterById: state => id => state.newslettersById[id] || null,
        meta: state => state.meta,
        unreadCount: state => state.unreadCount
    }
}
